import { css } from 'styled-components';
import { colors } from 'variables';

export const tabConstants = {
    height: '40px',
    overlap: '6px'
};

export const dialog = {
    height: '75vh',
    maxHeight: 'fit-content',
    width: '375px',
    bottom: '96px',
    right: '14px',
    borderRadius: '8px',
    textColor: colors.negative,
    primaryColor: colors.positive,
    shadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    breakpointPixels: '576px',
    breakpoint: '@media (min-width: 576px)'
};

export const dialogCss = css`
    height: ${dialog.height};
    max-height: ${dialog.maxHeight};
    width: ${dialog.width};
    bottom: ${dialog.bottom};
    right: ${dialog.right};
    border-radius: ${dialog.borderRadius};
`;
